import { Action } from '@ngrx/store';

import { TokenActions, TokenActionTypes } from '@actions/token.actions';
import { FetchFromLocalStorage } from '@common/helpers/fetch-from-local-storage.helper';
import { TokenState } from 'state';

const emptyState: TokenState = {
    userTokens: { access_token: '', expires_in: 0, refresh_token: '', token_type: '' }
};

export const initialState: TokenState = FetchFromLocalStorage('token') || emptyState;

export function tokenReducer(state = initialState, action: Action): TokenState {
    const specificAction: TokenActions = action as TokenActions;
    switch (specificAction.type) {
        case TokenActionTypes.Set:
            return { ...state, userTokens: specificAction.payload };

        case TokenActionTypes.Unset:
            return { ...emptyState };

        default:
            return state;
    }
}
